import { useSelector } from "react-redux"
import { State } from "state/store"

export const getFlags = (state: State) => state.flags

export const useFlags = () => useSelector(getFlags)
